<template>
    <div>
        <div class="upload-photo" v-if="list.length">
            <div class="upload-list" v-for="(item,index) in list" :key="index">
                <img :src="item|img_oss" class="img_oss-small">
                <div class="upload-list-cover">
                    <Icon type="eye" v-image-preview="{item,list}"></Icon>
                </div>
            </div>
        </div>
        <div v-else>--</div>
    </div>
</template>
<script>
    export default {
        props: ['src'],
        computed: {
            list() {
                return this.$props.src ? typeof this.$props.src == 'string' ? [this.$props.src] : this.$props.src : []
            }
        }
    }
</script>